export enum LAYOUT_VARIANT {
  GRID = 'grid',
  LIST = 'list',
}

export enum LAYOUT_VARIANT_ORDER {
  grid = 1,
  list,
}
